module.exports = __webpack_public_path__ + "static/img/publicity-bg1.b44adeb.png";


//////////////////
// WEBPACK FOOTER
// ./static/publicity-bg1.png
// module id = 7sVJ
// module chunks = 1